import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { EICFConsentsApi } from '../../../apis/EICFApi/EICFConsentsApi.ts';

export function useGetActiveEICFConsent(enabled: boolean = true) {
  return useQuery({
    queryKey: [QueryKeys.eicfActiveConsent],
    queryFn: () => EICFConsentsApi.getActive(),
    enabled,
    staleTime: 30_000,
    refetchOnMount: 'always',
  });
}
